import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet } from '@/api/async-util'

const types = {
    GET_COUNTRIES: createAsyncMutation('GET_COUNTRIES'),
    GET_CURRENCIES: createAsyncMutation('GET_CURRENCIES'),
    GET_STATES: createAsyncMutation('GET_STATES'),
    GET_PROVINCES: createAsyncMutation('GET_PROVINCES'),
    GET_ORDER_STATUSES: createAsyncMutation('GET_ORDER_STATUSES'),
    GET_ACTIVATION_TYPES: createAsyncMutation('GET_ACTIVATION_TYPES'),
    GET_LOCATIONS: createAsyncMutation('GET_LOCATIONS'),
}

const enums = {
    state: {},
    mutations: {},
    actions: {
        // GET
        getLocations(store) {
            let url = api.enum + 'Locations'
            return doAsyncGet(store, { url, mutationTypes: types.GET_LOCATIONS })
        },
        getCountries(store) {
            let url = api.enum + 'Countries'
            return doAsyncGet(store, { url, mutationTypes: types.GET_COUNTRIES })
        },
        getCanadianProvinces(store) {
            let url = api.enum + 'CanadianProvinces'
            return doAsyncGet(store, { url, mutationTypes: types.GET_PROVINCES })
        },
        getAmericanStates(store) {
            let url = api.enum + 'AmericanStates'
            return doAsyncGet(store, { url, mutationTypes: types.GET_STATES })
        },
        getActivationTypes(store) {
            let url = api.enum + 'ActivationTypes'
            return doAsyncGet(store, { url, mutationTypes: types.GET_ACTIVATION_TYPES })
        },
        getOrderStatuses(store) {
            let url = api.enum + 'OrderStatuses'
            return doAsyncGet(store, { url, mutationTypes: types.GET_ORDER_STATUSES })
        },
        getCurrencies(store, payload) {
            let url = api.enum + 'Currencies'
            return doAsyncGet(store, { url, mutationTypes: types.GET_CURRENCIES })
        },

        // POST

        // PUT

        // DELETE
    },
    getters: {},
    types: types
}

export default enums
